import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SneAnswerService } from 'src/app/services/sne-answer.service';
import { HEADER_STATES } from 'src/app/shared/header/header.helper';
import { APP_COLORS } from 'src/global-styles';
import { SneCoachabilityBase } from '../sne-coachability.base';

@Component({
  selector: 'ets-cch-sne-intro',
  templateUrl: './cch-sne-intro.component.html',
  styleUrls: ['./cch-sne-intro.component.scss']
})
export class CchSneIntroComponent extends SneCoachabilityBase implements OnInit {

  headerState: HEADER_STATES = HEADER_STATES.BACK;
  APP_COLORS = APP_COLORS;
  numberText = '03.';

  constructor(route: ActivatedRoute, router: Router, sneAnswerService: SneAnswerService) {
    super(route, router, sneAnswerService);
  }

  onClick(){
    this.getNextQuestion();
  }

  ngOnInit(): void {
    this.processParams();
  }

}